import spriteHref from "@/assets/icon.svg"
import type { SVGProps } from "react"
import type { IconName } from "@/icons/types.ts"

export function Icon({
  name,
  ...props
}: SVGProps<SVGSVGElement> & {
  name: IconName
}) {
  return (
    <svg height="1rem" width="1rem" {...props}>
      <use href={`${spriteHref}#${name}`} />
    </svg>
  )
}
